import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { MyTimesheetFilterBody } from "my-timesheet/components";
import {
  useMyTimesheetFilterCounterState,
  useMyTimesheetFilterOpenState,
} from "my-timesheet/hooks";
import { OcRoleFilterGroupedSubtypes } from "oc/components";
import { PRODUCTS, RoleCategoriesT } from "oc/configs/constants";
import { useOcCurrentUserState, useOcRoleFilters } from "oc/hooks";

interface MyTimesheetContractsFilterProps {
  data: {
    usersSummaryList?: {
      rows?: Array<{
        employeeName: string;
        requestedCost: number;
      }>;
    };
  };
  role: RoleCategoriesT;
}

export const MyTimesheetContractsFilter = ({
  data,
  role,
}: MyTimesheetContractsFilterProps) => {
  const { t } = useTranslation();

  const { state: openedFilter } = useMyTimesheetFilterOpenState();
  const { state: counter, setState: updateCounter } =
    useMyTimesheetFilterCounterState();

  let { contractCode: contract } = useOcCurrentUserState();

  const product = PRODUCTS.MYTIMESHEET;
  const { roleFilters, handleAddFilter, handleRemoveFilter } = useOcRoleFilters(
    {
      contract,
      product,
      role,
      id: "MyTimesheetContractsFilter",
    },
  );

  const list = data?.usersSummaryList?.rows || [];

  const formattedData = list?.map((row) => ({
    ...row,
    employeeName: t(row.employeeName),
    requestedCost: new Intl.NumberFormat("hu-HU", {
      style: "currency",
      currency: "HUF",
      maximumSignificantDigits: 3,
    }).format(row.requestedCost),
  }));

  useEffect(() => {
    const length = formattedData?.length || 0;
    if (counter["contract"] !== length) {
      updateCounter({ ...counter, contract: length });
    }
  }, [counter, formattedData?.length, updateCounter]);

  return (
    <MyTimesheetFilterBody
      open={openedFilter["contract"]}
      width="697px"
      type="contract"
    >
      <Box padding="16px">
        <OcRoleFilterGroupedSubtypes
          handleAddItem={handleAddFilter}
          handleRemoveItem={handleRemoveFilter}
          product={product}
          role={role}
          queryType="notAdmin"
          roleFilters={roleFilters}
          isCheckbox
        />
      </Box>
    </MyTimesheetFilterBody>
  );
};

export default MyTimesheetContractsFilter;
